import React from 'react';
import { theme as careTheme } from '@care/material-ui-theme';
import { Box, useMediaQuery } from '@mui/material';

interface LayoutProps {
  children: React.ReactChild[] | React.ReactChild;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isMobile = useMediaQuery(careTheme.breakpoints.down('sm'));
  const cloudImage = !isMobile && (
    <Box
      component="img"
      src="https://www.care.com/img/cms/web/careAtWork/directEnrollment/Cloud-2.png"
      sx={{
        height: '197px',
        width: '558px',
        position: 'absolute',
        right: 0,
        bottom: 0,
        zIndex: 0,
      }}
      alt="cloud"
    />
  );

  return (
    <Box
      component="div"
      sx={(theme) => ({
        background: theme.palette.grey[100],
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        minHeight: { sm: 'calc(100vh - 103.98px - 400px)' }, // header height - footer height
        pt: { xs: 4, sm: 6 },
        overflow: { sm: 'hidden' },
        '&>*': {
          zIndex: 1,
        },
      })}>
      {children}
      {cloudImage}
    </Box>
  );
};

export default Layout;
